import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { RouteInfo } from './../_models/Portal/Menu';
import { PortalService } from '@app/_services/Portal/portal.services';
import { first } from 'rxjs/operators';
import { AccountService } from '@app/_services';
import { UserData } from '@app/_models';
import { BreakpointObserver } from '@angular/cdk/layout';
import { RolesUsuario } from '@app/_models/Roles';
import { environment } from '@environments/environment';
import {Clipboard} from '@angular/cdk/clipboard';
declare const $: any;

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    standalone: false
})
export class SidebarComponent implements OnInit {
  public menuItems: RouteInfo[];
  private dataUser: UserData;
  ps: any;
  public isAgente: boolean = false;
  public idMembresia: number | null = null;
  
  constructor(
    private breakpointObserver: BreakpointObserver,
    private portalService: PortalService,
    private accountService: AccountService,
    private clipboard: Clipboard
  ) {}

  toggle() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('nav-open');
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.dataUser = this.accountService.userInfo;

    if (this.dataUser !== null) {
      console.log('dataUser', this.dataUser);
      this.idMembresia = this.dataUser.MembresiaID ?? null;
      this.portalService
        .getMenuByRole(this.dataUser.Role)
        .pipe(first())
        .subscribe({
          next: (result) => {
            this.menuItems = result;
            localStorage.setItem('menuItems', JSON.stringify(result));
          },
          error: (error) => {
            console.log('error');
          },
        });

        if (this.dataUser.Role == RolesUsuario.AgenteRole) {
             
          this.isAgente = true;
        }
    }

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector('.sidebar .sidebar-wrapper')
      );
      this.ps = new PerfectScrollbar(elemSidebar);
    }
  }

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  IsAgente() {
    return this.isAgente;
  }

  linkReferido() {
    
    
    let url = environment.AutoServicio + this.dataUser['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

    this.clipboard.copy(url);
    //window.open(url, "_blank");
   // const type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    $.notify({
      icon: 'notifications',
      message: 'Se copió tu link de referido al portapapeles.'
  }, {
      type: 'success',
      timer: 1000,
      placement: {
          from: 'top',
          align: 'right'
      },
      template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
  });


}
}
